import { purify } from "../../_src/components/purify";

export function searchAndloadMoreGaleria() {
    var btnLoadMore = document.querySelector("[data-action=load-more-galeria]")

    function loadMore(loadMore) {
        var form = document.querySelector('#filter-photos');
        var data = new FormData(form);

        btnLoadMore ? btnLoadMore.classList.add("loading") : ''

        if (!loadMore) {
            document.querySelector("#result-photos").innerHTML = ""
            document.querySelector(".loader-photo").classList.remove("hidden")
        }

        document.querySelectorAll("#filter-photos fieldset").forEach(function(el) {
            el.classList.add("disabled")
        })

        var pagina = loadMore ? btnLoadMore.getAttribute("data-page") : 1;

        fetch(`/acervo-digital/galeria-de-fotos/ajax/galeria/p${pagina}?&loadmore=${loadMore}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#load-more-galeria").insertAdjacentHTML('beforebegin', response);

                if ( parseInt(btnLoadMore.dataset.page) > parseInt(btnLoadMore.dataset.totalpages)) {
                    btnLoadMore.remove()
                }

            } else {
                document.querySelector("#result-photos").innerHTML = purify(response);

                searchAndloadMoreGaleria();
            }

        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            if (!loadMore) {
                document.querySelector(".loader-photo").classList.add("hidden")
            }

            btnLoadMore ? btnLoadMore.classList.remove("loading") : ''

            document.querySelectorAll("#filter-photos fieldset").forEach(function(el) {
                el.classList.remove("disabled")
            })

        });
    }

    if (btnLoadMore) {
        btnLoadMore.addEventListener("click", function() { loadMore(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);
    }

    document.querySelector("#filter-photos").addEventListener("submit", function(event) { event.preventDefault(), setTimeout(() => { loadMore(false) }, 100),btnLoadMore ? btnLoadMore.dataset.page = "1" : "1" }, false);
}


if (document.querySelector("#filter-photos")) {
    searchAndloadMoreGaleria();
}
